export const megabytesToBytes = (mb: number) => mb * 1024 * 1024
